import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import App from "./App";
import { initTheme } from "./theme";
import "leaflet/dist/leaflet.css";
import "./leaflet-fix";

// Automatically attach Bearer token to all Axios HTTP requests
axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token && token !== "undefined" && token !== "null") {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
